<template>
	<div v-bind="$attrs" v-on="$listeners" class="display-flex flex-row">
		<slot />
	</div>
</template>
<script>
export default { name: 'Row' };
</script>
